var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-progressbar"},_vm._l((_vm.totalSteps + 1),function(stepIndex){return _c('span',{key:stepIndex,staticClass:"step-progressbar__step",class:[
      _vm.currentStepIndex + 1 >= stepIndex
        ? 'step-progressbar__step--enabled'
        : '',
      _vm.currentStepIndex + 1 == stepIndex
        ? 'step-progressbar__step--current'
        : ''
    ]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }